import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Footer.tsx — build stamp, ported from Anvil's. Shown on the shell pages only; the editor
// workspace is full-height and would lose the room (Anvil hides it on its game page for the same
// reason).
import { Component } from "react";
import { BuildLines } from "./BuildDetails";
import { fetchBuildInfo } from "./ShellApi";
export class Footer extends Component {
    constructor() {
        super(...arguments);
        this.state = { buildInfo: null };
    }
    async componentDidMount() {
        try {
            this.setState({ buildInfo: await fetchBuildInfo() });
        }
        catch {
            // fail silently — keep footer clean
        }
    }
    render() {
        const { buildInfo } = this.state;
        return (_jsx("footer", { className: "border-t border-slate-800 bg-slate-900 py-6 text-slate-400", children: _jsxs("div", { className: "container mx-auto text-center text-sm space-y-1", children: [_jsxs("p", { children: ["\u00A9 ", new Date().getFullYear(), " ", _jsx("span", { className: "font-semibold text-slate-200", children: "Twist Games" }), ". All rights reserved."] }), _jsx("div", { className: "text-xs text-slate-500 space-y-0.5", children: buildInfo ? _jsx(BuildLines, { info: buildInfo }) : _jsx("p", { children: "Fetching build info..." }) })] }) }));
    }
}
